import { Injectable } from '@angular/core';
import {OtpResponse, VitalityRecommendation, VitalityToolExcelDropDownOptions} from '../../api/models';

@Injectable()
export class GlobalService {
  private _isDependent: boolean;
  private _isEligible: boolean;
  private _isNotEligible: boolean;
  private _loggedIn: boolean;
  private _redirect: boolean;
  private _productCode: string;
  private _referenceNumber: any;
  private _fragment: string;
  private _premiumAmount: string;
  private _idNumber: string;
  private _channelAddress: string;
  private _crossSellRecommendation: VitalityRecommendation;
  private _dependents: any;
  private _healthProduct: boolean;
  private _lifeProduct: boolean;
  private _neitherProduct: boolean;
  private _otpId: string;
  private _entityNumber: string;
  private _cellphoneNumber: string;
  private _otpResponse: OtpResponse;
  private _medium: string;
  private _isVitalityActive: boolean;
  private _vitalityExcelDropDownOptions: VitalityToolExcelDropDownOptions;
  private _name: string;
  private _surname: string;
  private _agentCode: string;
  private _pageTitle: string;
  private _email: string;
  private _isSpouseOrDependent: boolean;

  get isDependent(): boolean {
    return this._isDependent;
  }

  set isDependent(value: boolean) {
    this._isDependent = value;
  }

  get isEligible(): boolean {
    return this._isEligible;
  }

  set isEligible(value: boolean) {
    this._isEligible = value;
  }

  get isNotEligible(): boolean {
    return this._isNotEligible;
  }

  set isNotEligible(value: boolean) {
    this._isNotEligible = value;
  }

  get loggedIn(): boolean {
    return this._loggedIn;
  }

  set loggedIn(value: boolean) {
    this._loggedIn = value;
  }

  get redirect(): boolean {
    return this._redirect;
  }

  set redirect(value: boolean) {
    this._redirect = value;
  }

  get productCode(): string {
    return this._productCode;
  }

  set productCode(value: string) {
    this._productCode = value;
  }

  get referenceNumber(): any {
    return this._referenceNumber;
  }

  set referenceNumber(value: any) {
    this._referenceNumber = value;
  }

  get fragment(): string {
    return this._fragment;
  }

  set fragment(value: string) {
    this._fragment = value;
  }

  get premiumAmount(): string {
    return this._premiumAmount;
  }

  set premiumAmount(value: string) {
    this._premiumAmount = value;
  }

  get crossSellRecommendation(): VitalityRecommendation {
    return this._crossSellRecommendation;
  }

  set crossSellRecommendation(value: VitalityRecommendation) {
    this._crossSellRecommendation = value;
  }

  get idNumber(): string {
    return this._idNumber;
  }

  set idNumber(value: string) {
    this._idNumber = value;
  }

  get channelAddress(): string {
    return this._channelAddress;
  }

  set channelAddress(value: string) {
    this._channelAddress = value;
  }

  get dependents(): any {
    return this._dependents;
  }

  set dependents(value: any) {
    this._dependents = value;
  }

  get healthProduct(): boolean {
    return this._healthProduct;
  }

  set healthProduct(value: boolean) {
    this._healthProduct = value;
  }

  get lifeProduct(): boolean {
    return this._lifeProduct;
  }

  set lifeProduct(value: boolean) {
    this._lifeProduct = value;
  }

  get neitherProduct(): boolean {
    return this._neitherProduct;
  }

  set neitherProduct(value: boolean) {
    this._neitherProduct = value;
  }

  get otpId(): string {
    return this._otpId;
  }

  set otpId(value: string) {
    this._otpId = value;
  }

  get entityNumber(): string {
    return this._entityNumber;
  }

  set entityNumber(value: string) {
    this._entityNumber = value;
  }

  get cellphoneNumber(): string {
    return this._cellphoneNumber;
  }

  set cellphoneNumber(value: string) {
    this._cellphoneNumber = value;
  }

  get otpResponse(): OtpResponse {
    return this._otpResponse;
  }

  set otpResponse(value: OtpResponse) {
    this._otpResponse = value;
  }

  get medium(): string {
    return this._medium;
  }

  set medium(value: string) {
    this._medium = value;
  }

  get isVitalityActive(): boolean {
    return this._isVitalityActive;
  }

  set isVitalityActive(value: boolean) {
    this._isVitalityActive = value;
  }


  get vitalityExcelDropDownOptions(): VitalityToolExcelDropDownOptions {
    return this._vitalityExcelDropDownOptions;
  }

  set vitalityExcelDropDownOptions(value: VitalityToolExcelDropDownOptions) {
    this._vitalityExcelDropDownOptions = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get surname(): string {
    return this._surname;
  }

  set surname(value: string) {
    this._surname = value;
  }


  get agentCode(): string {
    return this._agentCode;
  }

  set agentCode(value: string) {
    this._agentCode = value;
  }

  get pageTitle(): string {
    return this._pageTitle;
  }

  set pageTitle(value: string) {
    this._pageTitle = value;
  }


  get email(): string {
    return this._email;
  }

  set email(value: string) {
    this._email = value;
  }


  get isSpouseOrDependent(): boolean {
    return this._isSpouseOrDependent;
  }

  set isSpouseOrDependent(value: boolean) {
    this._isSpouseOrDependent = value;
  }

  scrollToTop(): void {
    window.scrollTo({behavior: 'smooth', top: 0});
    window.parent.scrollTo({behavior: 'smooth', top: 0});
  }

  constructor() { }
}
